module.exports = ".action-manual {\n    padding: 0;\n    vertical-align: middle;\n}\n\n.padding-left-0 {\n    padding-left: 0;\n}"